











import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { orderList, getPartnerInfo } from '@/utils/api';
interface nowSearchItem {
  value: string;
  code: string;
}
@Component
export default class Name extends Vue {
  @Prop(Object) searchItem!: Object;
  // 接收输入提示信息
  @Prop(String) inputPlaceholder!: String;
  // 接收父组件传值 监视值的变化 赋给当前值
  @Watch('searchItem', { deep: true })
  searchValueHandler(newval, oldval) {
    this.nowSearchItem = newval;
  }
  //当前值的变化 通知父组件改变
  @Watch('nowSearchItem', { deep: true })
  nowSearchValueHandler(newval, oldval) {
    this.$emit('fuzzySearchValue', newval);
  }
  nowSearchItem: nowSearchItem = {
    value: '',
    code: ''
  };
  mounted() {
    // 初始化赋值
    (this as any).nowSearchItem = { ...this.searchItem };
  }
  // 模糊搜索商家名称
  querySearch(queryString, cb) {
    if (queryString != '') {
      // 输入内容以后才去做模糊查询
      let callBackArr = []; // 准备一个空数组，此数组是最终返给输入框的数组
      setTimeout(() => {
        getPartnerInfo({ partnerName: queryString })
          .then(res => {
            if (res) {
              callBackArr = res.map(item => {
                return {
                  value: item.partnerName,
                  code: item.partnerCode
                };
              });
              // 经过这么一波查询操作以后，如果这个数组还为空，说明没有查询到具有关联的数据，就直接返回给用户暂无数据
              if (callBackArr.length == 0) {
                cb([{ value: '暂无数据', code: '' }]);
              }
              // 如果经过这一波查询操作以后，找到数据了，就把装有关联数据的数组callBackArr呈现给用户
              else {
                cb(callBackArr);
              }
            }
          })
          .catch(err => {
            console.log(err);
            this.$message.error(err);
          });
      }, 1000);
    }
  }
  // 搜索后select 点击选中的
  handleSelect(item) {
    this.nowSearchItem = item;
    this.$emit('fuzzySearchValue', item);
  }
}
